import React from 'react';
import { Dialogs, Button, Selector } from '@leverege/ui-elements';
import { Attributes } from '@leverege/ui-attributes';
import { Context } from '@leverege/plugin';
import SalesFlow from '../../views/salesFlow/SalesFlow';
import C from '../../views/salesFlow/Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const EMPTY = {};
const options = [{
  name: 'RecovR & Vehicle Sale',
  value: C.SALE_TYPES.VEHICLE_WITH_LOCATOR
}, {
  name: 'Vehicle Only Sale',
  value: C.SALE_TYPES.VEHICLE_ONLY
}, {
  name: 'Vehicle Wholesale',
  value: C.SALE_TYPES.VEHICLE_WHOLESALE
}, {
  name: 'Dealer Trade',
  value: C.SALE_TYPES.DEALER_TRADE
}];
export default class SalesFlowDetailRenderer {
  getValueComponent(object, cxt) {
    const {
      clientProps
    } = cxt;
    const {
      actions
    } = clientProps;
    const vehicle = Context.getTargetsOfType(cxt, 'vehicle')[0];
    const locationActions = actions.parent().parent();
    const locationData = locationActions?.getItem?.() || locationActions?.item?.(object?.location?.id);
    const location = {
      data: locationData,
      id: locationData?.id,
      ref: locationActions.getInterfaceUrl(),
      type: 'location'
    };
    const saleState = Attributes.get('vehicle.saleState', 'vehicle', vehicle.data);
    const onChange = ({
      value
    }) => {
      Dialogs.show({
        id: 'salesflow',
        component: SalesFlow,
        props: {
          context: cxt,
          vehicles: [vehicle],
          vehicle,
          location,
          actions,
          saleType: value
        }
      });
    };
    if (saleState === C.VEHICLE_SALE_STATES.PENDING_REMOVE_LOCATOR || saleState === C.VEHICLE_SALE_STATES.PENDING_REPLACE_LOCATOR) {
      /*#__PURE__*/_jsx(Button, {
        variant: "secondary",
        disabled: true,
        children: "Sale Pending"
      });
    }
    return /*#__PURE__*/_jsx(Selector, {
      title: "Mark as Sold",
      toggleVariant: "detailSecondary",
      values: options,
      onChange: onChange
    });
  }
  getComponents(object, cxt = EMPTY) {
    const {
      clientProps
    } = cxt;
    const {
      actions
    } = clientProps;
    const locationActions = actions.parent().parent();
    if (!locationActions) {
      return null;
    }
    return [{
      style: {
        justify: 'right'
      },
      component: this.getValueComponent(object, cxt)
    }];
  }
}